import styled from 'styled-components';

import Markdown from '@components/utils/Markdown';

export const Card = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  padding: 16px 16px 16px 0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  align-items: stretch;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: row; /* keep side by side on mobile */
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  flex: 0 0 200px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 120px;
    flex: 0 0 120px;
  }
`;

export const EventImage = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;

  img {
    object-fit: cover;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 140px;
  }
`;

export const Content = styled.div`
  flex: 1 1 auto;
  width: auto;
  max-width: none;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 0; /* allow flex text truncation */

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex: 1 1 auto;
    width: auto;
    max-width: none;
  }
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 8px;
  color: ${({ theme }) => theme.palette.darkGrey};
  /* line clamp to 2 lines */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Description = styled(Markdown)`
  font-size: 13px;
  line-height: 1.4;
  margin: 0 0 12px;
  color: ${({ theme }) => theme.palette.brownishGrey};
  flex: 0 0 auto;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
`;

export const Dates = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.primaryBrand};
  margin-bottom: auto; /* push button to bottom */
`;

export const Artist = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grey};
  margin: -4px 0 8px;
`;

export const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
`;

export const DetailButton = styled.button`
  padding: 8px 14px;
  border-radius: 6px;
  background: ${({ theme }) => theme.palette.primaryBrand};
  color: ${({ theme }) => theme.palette.white};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background 0.25s ease;
  &:hover {
    background: ${({ theme }) => theme.palette.primaryBrandSoft};
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
`;

export const ModalContent = styled.div`
  width: min(1200px, 90vw);
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
`;

export const NextEventsWrapper = styled.div`
  width: 100%;
`;

export const NextEventsArtistName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const NextEventsTitle = styled.div`
  font-size: 10px;
  font-weight: 600;
  margin: 4px 0;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const NextEventsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 4px;
  }
`;

export const NextEventItem = styled.span`
  font-size: 11px;
  padding: 4px 8px;
  background: ${({ theme }) => theme.palette.grey500}22;
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.darkGrey};
`;
export const KrokiButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  background-color: ${({ theme }) => theme.palette.B50};
  color: ${({ theme }) => theme.palette.B300};
  border: 1px solid ${({ theme }) => theme.palette.B50};
  padding: 0 8px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  text-decoration-line: underline;
  cursor: pointer;
  white-space: nowrap;
  width: max-content;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 8px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: grid;
  }
`;
export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;

  opacity: 1;
  animation: modalBounce 0.15s ease-in-out;

  @keyframes modalBounce {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;

  background-color: ${({ theme }) => theme.palette.white};
  transform: translate(-50%, -50%);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  z-index: 15;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.palette.D30};
  overflow: hidden;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: min(1000px, calc(100vw - 48px));
    height: min(770px, calc(100vh - 48px));
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const TitleWrapper = styled.div`
  flex: 1;

  & span {
    font-size: 20px;

    @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
      font-size: 24px;
    }
  }
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.palette.NL30};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.palette.NL100};
    border-radius: 10px;
  }
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    min-height: 0;
    flex: 1;
  }
`;

export const ImageScrollContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.palette.NL30};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.palette.NL100};
    border-radius: 10px;
  }

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    overflow: hidden;
    justify-content: center;
    min-height: 0;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  width: 100%;
  max-width: 860px;
  aspect-ratio: 860 / 470;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  & img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 960px;
    aspect-ratio: 960 / 580;
    margin: 0 auto;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
`;

export const DescriptionBox = styled.div`
  width: 100%;
  height: 100px;
  padding: 8px;
  background-color: ${({ theme }) => theme.palette.NL20};
  border-radius: 8px;
  overflow-y: auto;
  display: flex;
  align-items: flex-start;

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.palette.NL30};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.palette.NL100};
    border-radius: 10px;
  }
`;

export const FlexDatesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SingleDateWrapper = styled.div`
  width: fit-content;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.NL20};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  margin-bottom: 24px;
`;

export const BottomDivider = styled.div`
  width: 100%;
  height: 5px;
  background-color: ${({ theme }) => theme.palette.NL100};
  border-radius: 2.5px;
  margin-top: 10px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: none;
  }
`;
export const MobileImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  width: 860px;
  height: 470px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  & img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
